// PROPOSITO: juntar las rutas de los tres roles y decidir a donde cae quien llega a la raiz.
// DEPENDENCIAS: react-router-dom, las tres listas de rutas por rol.

import { createBrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import { rutasDeAlumna } from './alumna.routes'
import { rutasDeEntrenadora } from './entrenadora.routes'
import { rutasDeAdmin } from './admin.routes'
import { Raiz } from './Raiz'

const Entrar = lazy(() => import('@/pages/Entrar'))
const NoEncontrada = lazy(() => import('@/pages/NoEncontrada'))
const Privacidad = lazy(() => import('@/pages/Privacidad'))
const PrivacidadDeSalud = lazy(() => import('@/pages/PrivacidadDeSalud'))

export const router = createBrowserRouter([
  { path: '/', element: <Raiz /> },
  { path: '/entrar', element: <Entrar /> },
  // Enlace SEPARADO y publico en la home: lo exige Washington My Health My Data Act.
  { path: '/privacidad', element: <Privacidad /> },
  { path: '/privacidad-datos-de-salud', element: <PrivacidadDeSalud /> },
  ...rutasDeAlumna,
  ...rutasDeEntrenadora,
  ...rutasDeAdmin,
  { path: '*', element: <NoEncontrada /> },
])
